import { compact } from '@lglp/utils';
import { schema } from 'normalizr';

import { LinkDocument } from '../../../../../types';
import {
  FrequenciesEnum,
  Page,
  PageType,
} from '../../../../../types/page/page';
import { toLink, toNumber, toRichText, toText } from '../../../fields';
import { toFrequency } from '../../../mapping';
import { documentEntity } from './document';

const processPage: schema.StrategyFunction<Page> = (doc) =>
  compact<Partial<Page>>({
    meta: compact({
      title: toText(doc.data?.meta_title) || toText(doc.data?.title),
      description: doc.data?.meta_description,
      image: doc.data?.meta_image,
      indexed: doc.data?.meta_indexing !== 'non',
    }),
    seoText: doc?.data?.seo_text,
    sitemapPriority: toNumber(doc.data?.sitemap_priority, {
      min: 0,
      max: 1,
      defaultValue: 0.8,
    }),
    sitemapChangeFrequency:
      toFrequency(doc.data?.sitemap_change_frequency) || FrequenciesEnum.WEEKLY,
    breadcrumbParent: toLink(doc?.data?.breadcrumb_parent) as LinkDocument,
    title: toText(doc?.data?.title),
    chapeau: toRichText(doc?.data?.chapeau),
  }) as Page;

/**
 * Function to transform a prismic deprecated page to a document.
 */
export const deprecatedPageEntity = <T extends Page = Page>(
  type: PageType,
  { processStrategy, ...rest }: schema.EntityOptions<T>
): schema.Entity<T> =>
  documentEntity<T>(type, {
    processStrategy: (entity, parent, key) => ({
      ...processStrategy(entity, parent, key),
      ...processPage(entity, parent, key),
    }),
    ...rest,
  });
